import script from "./CreateNoteView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateNoteView.vue?vue&type=script&setup=true&lang=ts"

import "./CreateNoteView.vue?vue&type=style&index=0&id=e5696dd2&lang=scss"

const __exports__ = script;

export default __exports__